import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Alert,
} from '@storable/canaveral-components';
import Icon from '../../../modules/react/components/stateless/Icon';
import styles from './styles.scss';

const propTypes = {
  showNewSiteFlow: PropTypes.bool.isRequired,
  restartFlow: PropTypes.bool.isRequired,
};

const HostnameCertSettingsStatusPanelAlert = ({
  showNewSiteFlow,
  restartFlow,
}) => {
  let alertText = '';

  if (!showNewSiteFlow) {
    alertText = 'External SSL certificates will no longer be allowed after Month DD, YYYY.';
  } else if (restartFlow) {
    alertText = 'This domain has not yet been secured with an SSL certificate.';
  } else {
    alertText = 'Your SSL certificate is pending.';
  }

  return (
    <Col>
      <Alert context="warning" className={styles.statusPanelAlert}>
        <Icon id="warning-triangle" className={styles.warningIcon} />
        <div className={styles.warningText}>
          {alertText}
        </div>
      </Alert>
    </Col>
  );
};

HostnameCertSettingsStatusPanelAlert.propTypes = propTypes;

export default HostnameCertSettingsStatusPanelAlert;
